import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { Patient } from '~/domain/patient/patient';
import {
    patientRepositoryState,
    selectedPatientIdState,
} from '~/state/atoms/patientAtoms';

export default function useAllPatients() {
    const patientRepository = useRecoilValue(patientRepositoryState);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const [patients, setPatients] = useState<Patient[]>([]);

    useEffect(() => {
        const allPatients: Patient[] = patientRepository.getAll();
        if (Object.keys(allPatients).length > 0) setPatients(allPatients);
    }, [patientRepository, selectedPatientId]);

    return {
        selectedPatientId,
        patients,
    };
}
